module.exports = __webpack_public_path__ + "img/milestone__16.1ab6baa4.jpg";